const inspectTable = [
  {
    id: 1,
    label: "소방분야",
    check: false,
    title: "소방분야",
    note: "",
    list: [
      {
        id: 1,
        label: "내부마감재 방염기준 등의 적법여부",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "소화기, 화재탐지기 등 소방시설 상태",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "위험물질 및 화기관리의 적정성 여부",
        is_checked: "",
        note: "",
      },
      {
        id: 4,
        label: "방화문, 방화샷터의 정상작동상태 점검",
        is_checked: "",
        note: "",
      },
      {
        id: 5,
        label: "피난, 소화통로 확보여부, 유지관리 상태",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 2,
    label: "건축구조",
    check: false,
    title: "건축구조",
    note: "",
    list: [
      {
        id: 1,
        label: "피난시설 규정 등 건축법상 저촉여부",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: `지반이 침하되어 있는 곳은 없는가?
              - 건물 주변 지반의 단차 및 균열이 없어야 함
              - 건물 인근의 지하수 누출 없어야 함`,
        is_checked: "",
        html: true,
        note: "",
      },
      {
        id: 3,
        label: `건물이 기울어져 있지는 않은가?
              - 바닥은 기울이지 않고 창문은 원활하게 개폐되어야 함
              - 외벽은 수직상태를 유지하여야 함`,
        is_checked: "",
        html: true,
        note: "",
      },
      {
        id: 4,
        label: `균열은 없는가?
              - 구조체(기둥,보,슬래브,내력벽)에 균열 없어야 함`,
        is_checked: "",
        html: true,
        note: "",
      },
      {
        id: 5,
        label: `철근노출 및 부식, 박리, 박락된 곳은 없는가?
              - 철근 노출 및 콘크리트가 떨어지거나 들뜨지 않아야 함`,
        is_checked: "",
        html: true,
        note: "",
      },
      {
        id: 6,
        label: `구조체 단면손상 및 하중이 증가된 부분은 없는가?
              - 기둥,보,슬래브,내력벽의 설계 단면 손상이 없어야 함
              - 지붕 및 건물 내에 설계도에 없는 구조물,탱크 등 설치는 없어야 함.`,
        is_checked: "",
        html: true,
        note: "",
      },
      {
        id: 7,
        label: `철골재의 볼트체결 상태는 적정한가?
              - 접합부 볼트 누락 및 체결부위에 틈새 발생 없어야 함
              - 접합부 용접은 적합하게 시행 하여야 함`,
        is_checked: "",
        html: true,
        note: "",
      },
      {
        id: 8,
        label: `철골재 건축물이 손상된 곳은 없는가?
              - 철재의 부식으로 단면결손 및 도장 탈락 없어야 함
              - 기둥,보,슬래브의 휨, 처짐 등 손상 없어야 함
              - 철골 구조물의 구조내력 저하여부`,
        is_checked: "",
        html: true,
        note: "",
      },
    ],
  },
  {
    id: 3,
    label: "건축마감",
    check: false,
    title: "건축마감",
    note: "",
    list: [
      {
        id: 1,
        label: `지붕,옥상 마감은 적정한가?
              - 난간의 높이가 1.2m 이상이며, 난간살 기준에 적합하게 튼튼하게 설치하여야 함
              - 지붕 마감재의 탈락, 옥상에 비산 우려 물체가 없어야 함
              - 배수구멍의 걸림망 설치 및 기능 발휘에 문제 없어야 함
              - 방수층의 손상 및 잡초의 식생 없어야 함`,
        is_checked: "",
        html: true,
        note: "",
      },
      {
        id: 2,
        label: `내외부 마감재는 적합하게 설치되어 있는가?
              - 탈락,들뜸,추락의 위험이 없어야 함
              - 계단에 미끄럼방지시설 설치히여야 함
              - 내부 마감재는 과도한 변이가 없어야 함`,
        is_checked: "",
        html: true,
        note: "",
      },
      {
        id: 3,
        label: `환기구 덮개,점검로 상태는 적정한가?
              - 환기구 등 덮개는 변형,부식 등이 없어야 함
              - 점검로 또는 점검사다리는 변형, 부식이 없어야 함`,
        is_checked: "",
        html: true,
        note: "",
      },
      {
        id: 4,
        label: "담장,축대 등 부대시설의 안전성 여부",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 4,
    label: "전기분야",
    check: false,
    title: "전기분야",
    note: "",
    list: [
      {
        id: 1,
        label: "누전차단기 등 전기시설의 정상적동 여부",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: `전기안전관리 이행 여부
              - 일상,정기,정밀(연차) 점검 등 법정검사 수검이행(위탁시 갈음)
              - 전기실, 배전실 등 위험한 장소에 위험표지 설치`,
        is_checked: "",
        html: true,
        note: "",
      },
      {
        id: 3,
        label: "법정검사(사용전검사, 정기검사)수검 여부",
        is_checked: "",
        note: "",
      },
      {
        id: 4,
        label: "전기기계,기구 등으로 인한 위험 방지 조치",
        is_checked: "",
        note: "",
      },
      {
        id: 5,
        label: "전선 배선불량 및 문어발식 콘센트 사용여부",
        is_checked: "",
        note: "",
      },
      {
        id: 6,
        label: "조명탑 등 전기시설물의 유지관리 상태",
        is_checked: "",
        note: "",
      },
      {
        id: 7,
        label: `정전기 및 낙뢰로 인한 재해 예방 조치 등
              - 정전기로 인한 화재 폭발 방지
              - 피뢰설비의 설치 등`,
        is_checked: "",
        html: true,
        note: "",
      },
      {
        id: 8,
        label: "승강기 등 안전관리 및 작동상태",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 5,
    label: "가스분야",
    check: false,
    title: "가스분야",
    note: "",
    list: [
      {
        id: 1,
        label: "가스용기 관리실태 및 가연성 물질 방치여부",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "가스차단기, 경보기 등 정상작동 여부",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "가스기기 이용실태 및 시설기준 적정여부",
        is_checked: "",
        note: "",
      },
      {
        id: 4,
        label: "가스보일러의 흡·배기구시설 설치상태",
        is_checked: "",
        note: "",
      },
      {
        id: 5,
        label: "지하실 환기 및 관리상태 확인",
        is_checked: "",
        note: "",
      },
      {
        id: 6,
        label: "가스밸브 노후여부, 배관매설, 고정상태",
        is_checked: "",
        note: "",
      },
      {
        id: 7,
        label: "가스사용 시, 주의사항 등 안전표어 부착여부",
        is_checked: "",
        note: "",
      },
    ],
  },
];
export default inspectTable
